import { useSelector, useDispatch } from 'react-redux'
import { setUser, initialState } from 'store/auth/userSlice'
import { apiSignIn, apiSignOut, apiSignUp, apiAccountIdDupCheck } from 'services/AuthService'
import { onSignInSuccess, onSignOutSuccess } from 'store/auth/sessionSlice'
import appConfig from 'configs/app.config'
import { useNavigate } from 'react-router-dom'
import useQuery from './useQuery'
import ServiceUtils from 'utils/ServiceUtils'
import { AUTH_CONSTANT } from 'constants/AuthConstant'

function useAuth() {
  const dispatch = useDispatch()

  const navigate = useNavigate()

  const query = useQuery()

  const { token, signedIn } = useSelector((state) => state.auth.session)

  const signIn = async (values) => {
    try {
      const resp = await apiSignIn(values)
      if (ServiceUtils.checkResult(resp.data.header) && resp.data.jwt?.accessToken) {
        // 회원가입 성공
        // sessionStorage.setItem("token", resp.data.jwt.accessToken);
        dispatch(onSignInSuccess(resp.data.jwt))
        const authority = [resp.data.userType]
        if (resp.data.b2bEnabled) {
          authority.push('B2B')
        }
        dispatch(
          setUser({
            email: resp.data.email,
            accountId: resp.data.accountId,
            userName: resp.data.name,
            userType: resp.data.userType,
            userTypeName: resp.data.userTypeName,
            phone: resp.data.phone,
            authority,
            userStatus: resp.data.userStatus,
          }
          )
        )
      }
      return resp.data
    } catch (errors) {
      return {
        status: 'failed',
        message: errors?.response?.data?.message || errors.toString(),
      }
    }
  }

  const signUp = async (values) => {
    try {
      const resp = await apiSignUp(values)
      console.log("resp", resp)
      // if (ServiceUtils.checkResult(resp.data.header)) {
      //   // 회원가입 성공
      //   navigate(`/sign-up-complete`)
      // } else {
      // }
      return resp.data
    } catch (errors) {
      return {
        status: 'failed',
        message: errors?.response?.data?.message || errors.toString(),
      }
    }
  }

  const handleSignOut = () => {
    dispatch(onSignOutSuccess())
    sessionStorage.removeItem(AUTH_CONSTANT.JWT);
    dispatch(setUser(initialState))
    navigate(appConfig.unAuthenticatedEntryPath)
  }

  const signOut = async () => {
    try {
      await apiSignOut()
      handleSignOut()
    } catch (errors) {
      console.log(errors.response.status)
      if(errors.response.status === 403) {
        handleSignOut()
      }
      // return {
      //   status: 'failed',
      //   message: errors?.response?.data?.message || errors.toString(),
      // }
    }
  }

  const accountIdDupCheck = async (values) => {
    try {
      const resp = await apiAccountIdDupCheck(values)

      return resp.data
    } catch (errors) {
      return {
        status: 'failed',
        message: errors?.response?.data?.message || errors.toString(),
      }
    }
  }

  return {
    authenticated: sessionStorage.getItem(AUTH_CONSTANT.JWT) !== null ? JSON.parse(sessionStorage.getItem(AUTH_CONSTANT.JWT)).accessToken : false,
    signIn,
    signUp,
    signOut,
    accountIdDupCheck,
  }
}

export default useAuth
